/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import { css } from '@emotion/react';
import type { FC } from 'react';
import * as Styled from './styled';
import type { IconScaleStarsProps } from './types';

export * from './types';

export const IconScaleStars: FC<IconScaleStarsProps> = (props) => {
  const { amount, onClick, onMouseOver, ...rest } = props;

  return (
    <Styled.Icons {...rest}>
      <Styled.Filled
        css={css`
          width: ${amount * 20}%;
        `}
      >
        {[1, 2, 3, 4, 5].map((number, index) => {
          return (
            <span
              key={index}
              onMouseOver={() => onMouseOver?.(index)}
              onClick={() => onClick?.(index)}
            >
              ★
            </span>
          );
        })}
      </Styled.Filled>
      <Styled.Empty>
        {[1, 2, 3, 4, 5].map((number, index) => {
          return (
            <span
              key={index}
              onMouseOver={() => onMouseOver?.(index)}
              onClick={() => onClick?.(index)}
            >
              ★
            </span>
          );
        })}
      </Styled.Empty>
    </Styled.Icons>
  );
};
